import api from '../../api'
import { InvoicingFunnelData, FunnelPeriod } from './funnelModel'

export const getInvoicingFunnel = async (period: FunnelPeriod) => {
  const response = await api.get<InvoicingFunnelData>('/web/admin/invoicing-funnel', {
    params: { period }
  })
  return response.data
}

export const refreshInvoicingFunnel = async () => {
  await api.post('/web/admin/invoicing-funnel/refresh')
}
